import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";
import UploadTemplate from "./pages/UploadTemplate";
import EditTemplate from "./pages/EditTemplate";
import AdminLogin from "./pages/AdminLogin";
import { auth } from "./Firebase";
import "./App.css";

// Hard-coded admin credentials
const ADMIN_EMAIL = "admin@toutmate.co.uk";
const ADMIN_PASSWORD = "marlow";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((firebaseUser) => {
      if (firebaseUser) {
        // Set user with email and default role
        setUser({ role: "user", email: firebaseUser.email });
        // Set specific users as admin if email matches
        if (firebaseUser.email === ADMIN_EMAIL) {
          setUser({ role: "admin", email: firebaseUser.email });
        }
      } else {
        setUser(null);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Dashboard route - both at root and /dashboard */}
          <Route
            path="/"
            element={
              <div>
                <header className="App-header">
                  <img
                    src="/toutmate_logo_transparent.png"
                    alt="Website Logo"
                    className="logo"
                  />
                </header>
                <Dashboard user={user} />
              </div>
            }
          />
          <Route
            path="/dashboard"
            element={
              <div>
                <header className="App-header">
                  <img
                    src="/toutmate_logo_transparent.png"
                    alt="Website Logo"
                    className="logo"
                  />
                </header>
                <Dashboard user={user} />
              </div>
            }
          />

          {/* Admin login route */}
          <Route
            path="/admin-login"
            element={
              <AdminLogin
                setUser={setUser}
                adminEmail={ADMIN_EMAIL}
                adminPassword={ADMIN_PASSWORD}
              />
            }
          />

          {/* Admin dashboard route */}
          <Route
            path="/admin-dashboard"
            element={
              user && user.role === "admin" ? <Admin /> : <Navigate to="/" />
            }
          />

          {/* Upload Template route */}
          <Route
            path="/upload-template"
            element={user ? <UploadTemplate /> : <Navigate to="/" />}
          />

          {/* Edit Template route with dynamic templateId */}
          <Route
            path="/edit-template/:templateId"
            element={user ? <EditTemplate /> : <Navigate to="/" />}
          />

          {/* Catch all route - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
